type Callback = () => void;

export const customSetInterval = (callBack: Callback, ms: number): number =>
    setInterval(callBack, ms) as unknown as number;
